<template>
  <div
      :class="['position-relative horizontal-space-container', editable ? 'edit-mode' : '', !config.showAsPercentage ? 'ml-2 mr-2' : '', isTopBottomBar ? 'full-height' : '']"
      :style="{
          width: getWidth()
          }"
  >
    <div
      style="position: absolute; left: -3px; width: 80px; height: 100%;"
    >
      <slot name="dropzone"></slot>
    </div>
    <editor-overlay
        v-if="editable"
        :active="editorSelected"
        :can-have-template="false"
        @editProperty="editProperty"
        @editTemplate="editTemplate"
        @removeBlock="$emit('removeBlock')"
    />
    <div

        :class="['horizontal-space', editable ? 'edit-mode' : '']">
    </div>
  </div>
</template>

<script>
import ElementMixin from "@/components/vForm/mixins/ElementMixin.js.vue";
import EditorOverlay from "./EditorOverlay";

export default {
  name: "Divider",
  components: {EditorOverlay},
  mixins: [ElementMixin],
  mounted() {
    this.increaseCounter();
  },
  methods: {
    getWidth() {
      const {width, showAsPercentage} = this.config;
      let widthVal = width;
      if (!width) {
        widthVal = 15;
      }
      if (showAsPercentage) {
        return (widthVal / 6) + 'vh';
      } else {
        return widthVal + 'px';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.horizontal-space-container {
  min-width: 15px;
  flex-grow: 1;
  min-height: 30px;

  &.full-height {
    height: 100%;
  }
}

.edit-mode {
  background-color: #e5e5f7;
  opacity: 0.8;
  background: repeating-linear-gradient(-45deg, var(--vform-editor-logo-color), var(--vform-editor-logo-color) 1px, #e5e5f7 1px, transparent 5px);
}
</style>